import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage
const isActive = localStorage.getItem('isActive') === 'true';

const initialState = {
  isActive: isActive,
  isHome: true,
};

const togglebuttonSlice = createSlice({
  name: 'toggle',
  initialState,
  reducers: {
    togglefunction: (state, action) => {
      state.isActive = action.payload;
      localStorage.setItem('isActive', action.payload); // ensure sync
    },
    menucontrol: (state, action) => {
      state.isHome = action.payload;
    },
  },
});

export const { togglefunction, menucontrol } = togglebuttonSlice.actions;
export default togglebuttonSlice.reducer;
